export interface INote {
	body?: string;
	contact_id?: number;
	title?: string;
	type?: string;
	user_id?: number;
}
